module.exports = __webpack_public_path__ + "img/lw-on.2f70b695.png";